export enum AgreementStatusCode {
    Agree = 1,
    NotAgree = 2,
    NotNow = 3
}
